import { DeployArgsResult } from '@block-explorer/entities';

export const getAmountFromDeploy = (args: DeployArgsResult): string => {
  const amountKey = Object.keys(args).find((key) =>
    key.toLowerCase().includes('amount')
  );
  const amountValue =
    amountKey && args[amountKey] ? args[amountKey].parsed : '0';

  return Array.isArray(amountValue) ? amountValue[0] : amountValue;
};
